module.exports = __webpack_public_path__ + "img/layout_right_3.9c251802.jpg";